// FND-01: the chart tone vocabulary. It lives at ensign level so an ensign
// (SpecraSwatch) and the lieutenant chart frame share one list. Colour in a
// chart means status (SAD-1000) or, for the Growth redesign tones, ownership
// (ours / theirs / legacy) and categorical identity. Every lookup holds
// complete literal class strings so Tailwind's JIT sees them.
/** Every chart mark colour. Status tones (SAD-1000) first, then the Growth redesign tones. */ export const SPECRA_CHART_TONES = [
    'good',
    'warn',
    'bad',
    'pending',
    'series',
    'ours',
    'ours-future',
    'theirs',
    'theirs-future',
    'legacy',
    'other',
    'cat-1',
    'cat-2',
    'cat-3',
    'cat-4',
    'cat-5',
    'cat-6',
    'cat-7',
    'cat-8',
    'ink'
];
/** CSS colour value per tone, for SVG fill/stroke and inline styles. */ export const chartToneVar = {
    good: 'var(--chart-good)',
    warn: 'var(--chart-warn)',
    bad: 'var(--chart-bad)',
    pending: 'var(--chart-pending)',
    series: 'var(--chart-series)',
    ours: 'var(--chart-ours)',
    'ours-future': 'var(--chart-ours-future)',
    theirs: 'var(--chart-theirs)',
    'theirs-future': 'var(--chart-theirs-future)',
    legacy: 'var(--chart-legacy)',
    other: 'var(--chart-other)',
    'cat-1': 'var(--chart-cat-1)',
    'cat-2': 'var(--chart-cat-2)',
    'cat-3': 'var(--chart-cat-3)',
    'cat-4': 'var(--chart-cat-4)',
    'cat-5': 'var(--chart-cat-5)',
    'cat-6': 'var(--chart-cat-6)',
    'cat-7': 'var(--chart-cat-7)',
    'cat-8': 'var(--chart-cat-8)',
    ink: 'var(--text-primary)'
};
/** Background utility per tone (complete literal strings for Tailwind JIT). */ export const chartToneBgClass = {
    good: 'bg-[var(--chart-good)]',
    warn: 'bg-[var(--chart-warn)]',
    bad: 'bg-[var(--chart-bad)]',
    pending: 'bg-[var(--chart-pending)]',
    series: 'bg-[var(--chart-series)]',
    ours: 'bg-[var(--chart-ours)]',
    'ours-future': 'bg-[var(--chart-ours-future)]',
    theirs: 'bg-[var(--chart-theirs)]',
    'theirs-future': 'bg-[var(--chart-theirs-future)]',
    legacy: 'bg-[var(--chart-legacy)]',
    other: 'bg-[var(--chart-other)]',
    'cat-1': 'bg-[var(--chart-cat-1)]',
    'cat-2': 'bg-[var(--chart-cat-2)]',
    'cat-3': 'bg-[var(--chart-cat-3)]',
    'cat-4': 'bg-[var(--chart-cat-4)]',
    'cat-5': 'bg-[var(--chart-cat-5)]',
    'cat-6': 'bg-[var(--chart-cat-6)]',
    'cat-7': 'bg-[var(--chart-cat-7)]',
    'cat-8': 'bg-[var(--chart-cat-8)]',
    ink: 'bg-[color:var(--text-primary)]'
};
/** Border-colour utility per tone. */ export const chartToneBorderClass = {
    good: 'border-[color:var(--chart-good)]',
    warn: 'border-[color:var(--chart-warn)]',
    bad: 'border-[color:var(--chart-bad)]',
    pending: 'border-[color:var(--chart-pending)]',
    series: 'border-[color:var(--chart-series)]',
    ours: 'border-[color:var(--chart-ours)]',
    'ours-future': 'border-[color:var(--chart-ours-future)]',
    theirs: 'border-[color:var(--chart-theirs)]',
    'theirs-future': 'border-[color:var(--chart-theirs-future)]',
    legacy: 'border-[color:var(--chart-legacy)]',
    other: 'border-[color:var(--chart-other)]',
    'cat-1': 'border-[color:var(--chart-cat-1)]',
    'cat-2': 'border-[color:var(--chart-cat-2)]',
    'cat-3': 'border-[color:var(--chart-cat-3)]',
    'cat-4': 'border-[color:var(--chart-cat-4)]',
    'cat-5': 'border-[color:var(--chart-cat-5)]',
    'cat-6': 'border-[color:var(--chart-cat-6)]',
    'cat-7': 'border-[color:var(--chart-cat-7)]',
    'cat-8': 'border-[color:var(--chart-cat-8)]',
    ink: 'border-[color:var(--text-primary)]'
};
/** Text-colour utility per tone (glyphs drawn with currentColor). */ export const chartToneTextClass = {
    good: 'text-[color:var(--chart-good)]',
    warn: 'text-[color:var(--chart-warn)]',
    bad: 'text-[color:var(--chart-bad)]',
    pending: 'text-[color:var(--chart-pending)]',
    series: 'text-[color:var(--chart-series)]',
    ours: 'text-[color:var(--chart-ours)]',
    'ours-future': 'text-[color:var(--chart-ours-future)]',
    theirs: 'text-[color:var(--chart-theirs)]',
    'theirs-future': 'text-[color:var(--chart-theirs-future)]',
    legacy: 'text-[color:var(--chart-legacy)]',
    other: 'text-[color:var(--chart-other)]',
    'cat-1': 'text-[color:var(--chart-cat-1)]',
    'cat-2': 'text-[color:var(--chart-cat-2)]',
    'cat-3': 'text-[color:var(--chart-cat-3)]',
    'cat-4': 'text-[color:var(--chart-cat-4)]',
    'cat-5': 'text-[color:var(--chart-cat-5)]',
    'cat-6': 'text-[color:var(--chart-cat-6)]',
    'cat-7': 'text-[color:var(--chart-cat-7)]',
    'cat-8': 'text-[color:var(--chart-cat-8)]',
    ink: 'text-[color:var(--text-primary)]'
};
/** Ink for a text label drawn ON a mark of that tone (>= 4.5:1 for every non-status tone, both themes). */ export const chartToneInk = {
    good: 'var(--chart-ink-inverse)',
    bad: 'var(--chart-ink-inverse)',
    series: 'var(--chart-ink-inverse)',
    ours: 'var(--chart-ink-inverse)',
    'cat-1': 'var(--chart-ink-inverse)',
    'cat-6': 'var(--chart-ink-inverse)',
    'cat-8': 'var(--chart-ink-inverse)',
    ink: 'var(--chart-ink-inverse)',
    warn: 'var(--chart-ink-strong)',
    theirs: 'var(--chart-ink-strong)',
    'cat-2': 'var(--chart-ink-strong)',
    'cat-3': 'var(--chart-ink-strong)',
    'cat-4': 'var(--chart-ink-strong)',
    'cat-5': 'var(--chart-ink-strong)',
    'cat-7': 'var(--chart-ink-strong)',
    pending: 'var(--text-primary)',
    'ours-future': 'var(--text-primary)',
    'theirs-future': 'var(--text-primary)',
    legacy: 'var(--text-primary)',
    other: 'var(--text-primary)'
};
/** Diagonal hatch for "not yet awarded / ordering ended / vacant". */ export const chartHatchBackground = 'repeating-linear-gradient(135deg, var(--chart-hatch-b) 0 var(--space-1-5), var(--chart-hatch-a) var(--space-1-5) calc(var(--space-1-5) + var(--stroke-thin)))';
